var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 15.75C19.1133 15.75 20.0833 16.72 20.0833 17.9167C20.0833 18.5128 19.8426 19.0526 19.4531 19.4444C19.0606 19.839 18.5172 20.0833 17.9167 20.0833C16.72 20.0833 15.75 19.1133 15.75 17.9167C15.75 16.72 16.72 15.75 17.9167 15.75ZM20.9886 19.9193C21.3647 19.3436 21.5833 18.6557 21.5833 17.9167C21.5833 15.8916 19.9417 14.25 17.9167 14.25C15.8916 14.25 14.25 15.8916 14.25 17.9167C14.25 19.9417 15.8916 21.5833 17.9167 21.5833C18.6601 21.5833 19.3519 21.3621 19.9297 20.9818L21.4682 22.5288C21.7603 22.8226 22.2351 22.8239 22.5288 22.5318C22.8226 22.2397 22.8239 21.7649 22.5318 21.4712L20.9886 19.9193Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.16839C2 7.65965 2.27716 7.18733 2.73216 6.92069L10.3874 2.43465C11.3763 1.85512 12.6237 1.85512 13.6126 2.43465L21.2678 6.92069C21.7228 7.18733 22 7.65965 22 8.1684V14.7507C21.0548 13.5334 19.5772 12.75 17.9167 12.75C16.5931 12.75 15.3858 13.2477 14.4716 14.0661C13.8032 13.5317 12.9411 13.2098 12 13.2098C9.87583 13.2098 8.15385 14.8496 8.15385 16.8724V22H3.53846C2.68879 22 2 21.3441 2 20.535V8.16839Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchHome);
export default __webpack_public_path__ + "static/media/search-home.41ddd03be8625b064768c80e68e67598.svg";
export { ForwardRef as ReactComponent };